exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ProgressBar_wrap_1Od7 {\n  margin-bottom: 4px;\n\n  width: 220px;\n}\n\n.ProgressBar_progress-ctn_nUgk {\n  position: relative;\n\n  height: 4px;\n\n  border-radius: 10px;\n  background-color: #c2c2c2;\n}\n\n.ProgressBar_progress_2f7S {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n\n  height: 4px;\n\n  border-radius: 10px;\n  background-color: transparent;\n\n  -webkit-transition: width 0.4s ease-in-out, background-color 0.15s ease-out;\n\n  transition: width 0.4s ease-in-out, background-color 0.15s ease-out;\n}\n\n.ProgressBar_progress--green_2hgX {\n  background-color: #09f19e;\n}\n\n.ProgressBar_progress--yellow_3LqD {\n  background-color: #ffe02c;\n}\n\n.ProgressBar_progress--red_1WM9 {\n  background-color: #f45151;\n}\n\n.ProgressBar_legend_JuRf {\n  margin-top: 2px;\n  margin-bottom: 4px;\n}\n", ""]);

// exports
exports.locals = {
	"wrap": "ProgressBar_wrap_1Od7",
	"progress-ctn": "ProgressBar_progress-ctn_nUgk",
	"progress": "ProgressBar_progress_2f7S",
	"progress--green": "ProgressBar_progress--green_2hgX",
	"progress--yellow": "ProgressBar_progress--yellow_3LqD",
	"progress--red": "ProgressBar_progress--red_1WM9",
	"legend": "ProgressBar_legend_JuRf"
};